import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=3c991f85&scoped=true&"
import script from "./TaskOverview.vue?vue&type=script&lang=js&"
export * from "./TaskOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c991f85",
  null
  
)

export default component.exports